import { useLang } from '@/i18n';
import styles from './index.module.scss';
import EcoTabSwiper from 'eco-design/sections/eco-tab-swiper';
import EcoSection from 'eco-design/base/eco-section';
import EcoSpace from 'eco-design/base/eco-space';

export default function Comp() {
    const { t } = useLang('dp3.page_v2.TabSwiperB');

    return (
        <div className={styles.comp} id="TabSwiperB">
            <EcoSpace />
            <EcoSection title={t('title')} />
            <EcoTabSwiper
                items={[
                    {
                        bottomContent: t('desc1'),
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1745459457738/1.jpg',
                        pad: 'https://websiteoss.ecoflow.com/upload/image/1745459457738/1.jpg',
                        h5: 'https://websiteoss.ecoflow.com/upload/image/1745459456918/1-h5.jpg',
                        tabLabel: t('tab1'),
                        tabValue: 'A1',
                    },
                    {
                        bottomContent: t('desc2'),
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1745459458099/3.jpg',
                        pad: 'https://websiteoss.ecoflow.com/upload/image/1745459458099/3.jpg',
                        h5: 'https://websiteoss.ecoflow.com/upload/image/1745459458361/3-h5.jpg',
                        tabLabel: t('tab2'),
                        tabValue: 'A2',
                    },
                    {
                        bottomContent: t('desc3'),
                        pc: 'https://websiteoss.ecoflow.com/upload/image/1745459458548/2.jpg',
                        pad: 'https://websiteoss.ecoflow.com/upload/image/1745459458548/2.jpg',
                        h5: 'https://websiteoss.ecoflow.com/upload/image/1745459457900/2-h5.jpg',

                        tabLabel: t('tab3'),
                        tabValue: 'A3',
                    },
                ]}
            />
            <EcoSpace />
        </div>
    );
}
